import { useQuery } from "@tanstack/react-query";
import { getReportSignedImageUrl } from "../../api/reports";

export const useReportSignedImageUrl = (reportId, enabled = true) => {
  return useQuery({
    queryKey: ["reportSignedImageUrl", reportId],
    queryFn: () => getReportSignedImageUrl(reportId),
    enabled: !!reportId && enabled,
    retry: (failureCount, err) => err?.response?.status !== 404 && failureCount < 2,
    staleTime: 1000 * 60 * 30,
    refetchOnWindowFocus: false,
  });
};
